// Returns true if a venue is part of GRN (Global Restaurant Network)
const isGrnVenue = (source) => {
  if (source && source?.name && source?.logo && source?.privacy_policy && source?.terms_of_service) {
    return true;
  }
  return false;
};

export default isGrnVenue;
